import React, { useEffect, useState } from "react";
import { adminApi } from "../../lib/api";
import { toast } from "sonner";

export default function AdminReturns() {
  const [returns, setReturns] = useState([]);
  const load = () => adminApi.get("/admin/returns").then((r) => setReturns(r.data));
  useEffect(() => { load(); }, []);

  const update = async (id, field, value) => {
    await adminApi.put(`/admin/returns/${id}`, { [field]: value });
    toast.success("Actualizado");
    load();
  };

  return (
    <div>
      <h1 className="font-heading font-bold text-3xl tracking-tighter mb-6">Devoluciones e incidencias</h1>
      <div className="bg-white border border-border rounded-sm overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-brand-ink text-white"><tr><th className="text-left px-3 py-2">Pedido</th><th className="text-left px-3 py-2">Tipo</th><th className="text-left px-3 py-2">Motivo</th><th className="text-left px-3 py-2">Estado</th><th className="text-left px-3 py-2">Resolución</th></tr></thead>
          <tbody>
            {returns.length === 0 ? <tr><td colSpan={5} className="py-10 text-center text-muted-foreground">Sin devoluciones. Se registran desde el detalle del pedido.</td></tr> :
             returns.map((r, i) => (
              <tr key={r.id} className={i % 2 ? "bg-secondary/40" : "bg-white"} data-testid={`return-row-${r.id}`}>
                <td className="px-3 py-2 font-mono">{r.order_number}</td>
                <td className="px-3 py-2">{r.kind}</td>
                <td className="px-3 py-2 max-w-xs truncate">{r.reason}</td>
                <td className="px-3 py-2">
                  <select value={r.status} onChange={(e) => update(r.id, "status", e.target.value)} className="text-xs border border-border rounded-sm px-2 py-1 bg-white">
                    <option value="abierta">Abierta</option>
                    <option value="en_revision">En revisión</option>
                    <option value="resuelta">Resuelta</option>
                    <option value="rechazada">Rechazada</option>
                  </select>
                </td>
                <td className="px-3 py-2"><input defaultValue={r.resolution} onBlur={(e) => update(r.id, "resolution", e.target.value)} placeholder="Resolución..." className="text-xs border border-border rounded-sm px-2 py-1 w-full" /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
